import { useEffect, useState } from 'react';

import FormError from '@/shared-components/error/components/FormError';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';

import ArtworkTerms from './components/ArtworkTerms';
import EditArtwork from './components/EditArtwork';
import SubmitArtworkDraft from './components/SubmitArtworkDraft';

import './index.css';

export default function SubmitButton({ 
  formState, 
  editMode, 
  formError, 
  setFormError, 
  termsAccepted, 
  setTermsAccepted
}) { 
  const [openArtworkTerms, setOpenArtworkTerms] = useState(false);
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);

  useEffect(() => {
    const areAllFieldsFilled = !!(
      ((
        (formState.artwork_shipping.artwork_shipping_own.payer === 'The collector' && parseInt(formState.artwork_shipping.artwork_shipping_own.price) > 0) &&
        (formState.artwork_shipping.artwork_shipping_rest.payer === 'The collector' && parseInt(formState.artwork_shipping.artwork_shipping_rest.price) > 0)
      ) ||
      (
        (formState.artwork_shipping.artwork_shipping_own.payer === 'My gallery') &&
        (formState.artwork_shipping.artwork_shipping_rest.payer === 'My gallery')
      ) ||
      (
        (formState.artwork_shipping.artwork_shipping_own.payer === 'The collector' && parseInt(formState.artwork_shipping.artwork_shipping_own.price) > 0) &&
        (formState.artwork_shipping.artwork_shipping_rest.payer === 'My gallery')
      ) ||
      (
        (formState.artwork_shipping.artwork_shipping_rest.payer === 'The collector' && parseInt(formState.artwork_shipping.artwork_shipping_rest.price) > 0) &&
        (formState.artwork_shipping.artwork_shipping_own.payer === 'My gallery')
      ))
      && termsAccepted
    );
    setAllFieldsFilled(areAllFieldsFilled);
  }, [formState, termsAccepted]);

  useEffect(() => {
    setFormError(prevErrors => {
      if (prevErrors === null) {
        return [];
      } else {
        return prevErrors.filter(error => error.element !== "artwork_terms");
      }
    });
  }, [termsAccepted]);

  return (
    <>
      {!editMode && (
        <PublicFormInput 
          element="artwork_terms" 
          type="checkbox"
          error={Array.isArray(formError) ? formError?.find(error => error.element === "artwork_terms") : null}
          value={termsAccepted} 
          onChange={(value) => {
            setTermsAccepted(value);
            if (value) {
              setFormError((prevErrors) => {
                return prevErrors ? prevErrors.filter((error) => error.element !== "artwork_terms") : [];
              });
            }
          }}
        >
    I have read and accept the {" "}
          <span className="submit-button-artwork-terms-opener" onClick={() => setOpenArtworkTerms(true)}>
      Artwork Agreement
          </span>. 
        </PublicFormInput>
      )}

      <ArtworkTerms open={openArtworkTerms} close={() => setOpenArtworkTerms(false)} />

      <input type="hidden" id="artwork_generic_error" />
      <FormError error={formError} element="artwork_generic_error" />

      {editMode ? (
        <EditArtwork 
          formState={formState} 
          setFormError={setFormError}  
        />
      ) : (
        <SubmitArtworkDraft 
          formState={formState} 
          setFormError={setFormError}
          termsAccepted={termsAccepted}
          allFieldsFilled={allFieldsFilled}
        />
      )}
    </>
  );
}
